/* eslint-disable import/prefer-default-export */
export const DEFAULT_SUMMARY = {
  subtotal: 0,
  discount: 0,
  tax: 0,
  total: 0,
  total_discount: 0,
  subtotal_with_discount: 0
};
